export default "__VITE_ASSET__BBLXBK6S__"